import React, { useState, useEffect } from "react"
import { Primary, Rating, LoadMore } from "./styles/button"
import { Icon } from "../../components"
import Color from "../../constants/Color"

export default function Button() {}

Button.Primary = function ButtonPrimary({ children, to, m, mt, mr, mb, ml, ...rest }) {
  return (
    <Primary to={to} {...rest} m={m} mt={mt} mr={mr} mb={mb} ml={ml}>
      {children}
      <Icon name="ph-arrow-right" color={Color.primary} />
    </Primary>
  )
}

Button.Rating = function ButtonRating({ rate, count, ...rest }) {
  const [color, setColor] = useState("")
  const [bgColor, setBgColor] = useState()
  let number = parseInt(rate)
  useEffect(() => {
    if (rate && number < 4) {
      setColor(Color.bad)
      setBgColor(Color.badBg)
    } else if (number > 3.9 && number < 7) {
      setColor(Color.ok)
      setBgColor(Color.okBg)
    } else if (number > 6.9 && number < 8) {
      setColor(Color.great)
      setBgColor(Color.greatBg)
    } else if (number > 7.9) {
      setColor(Color.superb)
      setBgColor(Color.superbBg)
    } else {
      setColor(Color.white)
    }

    // eslint-disable-next-line
  }, [number])

  return (
    <Rating {...rest} bg={bgColor} count={count} color={color}>
      {count ? "" : <Icon name="ph-star-fill" pt="1" mr="4" color={color} />}
      <p>{rate || count}</p>
    </Rating>
  )
}

Button.LoadMore = function ButtonLoadMore({ children, ...rest }) {
  return <LoadMore {...rest}>{children}</LoadMore>
}
